import { useState, useEffect } from 'react';
import { Table, Button, Drawer, Typography, message, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { api } from '../api';
import ContactForm from './ContactForm';

const { Text } = Typography;

export default function ContactsTab() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [drawer, setDrawer]     = useState({ open: false, data: null });

  const load = async () => {
    setLoading(true);
    try {
      setContacts(await api.contacts.list());
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    {
      title: 'Name',
      key: 'name',
      render: (_, c) => (
        <Space direction="vertical" size={0}>
          <Text>{[c.first_name, c.last_name].filter(Boolean).join(' ') || '–'}</Text>
          {c.company && <Text type="secondary">{c.company}</Text>}
        </Space>
      ),
    },
    { title: 'Telefon', dataIndex: 'phone', key: 'phone', render: v => v || '–' },
    { title: 'E-Mail', dataIndex: 'email', key: 'email', render: v => v || '–' },
    {
      title: '',
      key: 'actions',
      width: 60,
      render: (_, c) => (
        <Button size="small" icon={<EditOutlined />} onClick={() => setDrawer({ open: true, data: c })} />
      ),
    },
  ];

  return (
    <>
      <Table rowKey="id" columns={columns} dataSource={contacts} loading={loading} pagination={false} size="middle" />
      <Drawer
        title="Kontakt bearbeiten"
        open={drawer.open}
        onClose={() => setDrawer({ open: false, data: null })}
        width={480}
        destroyOnClose
      >
        {drawer.data && (
          <ContactForm contact={drawer.data} onSaved={() => { setDrawer({ open: false, data: null }); load(); }} />
        )}
      </Drawer>
    </>
  );
}
